import { testIds } from '../../testing/testIds';

interface DetailPanelLoadingProps {
  message?: string;
}

export function DetailPanelLoading({ message = 'Loading...' }: DetailPanelLoadingProps) {
  return (
    <div className="flex items-center justify-center py-12">
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary-600"></div>
      <span className="ml-3 text-gray-600">{message}</span>
    </div>
  );
}

interface DetailPanelErrorProps {
  message: string;
}

export function DetailPanelError({ message }: DetailPanelErrorProps) {
  return (
    <div
      className="rounded-lg border border-red-200 bg-red-50 p-4 text-red-700"
      data-testid={testIds.reportDashboard.error}
    >
      <p className="font-medium">Unable to load panel data.</p>
      <p className="text-sm mt-1">{message}</p>
    </div>
  );
}
